import { IconButton, IconButton_IconSizes } from '@ydistri/ds';
import React from 'react';
import { MdQrCode } from 'react-icons/md';
import { useLazyGetYPickLoginQRCodeQuery } from './apiYPickCredentials';
import { downloadBlob } from './yPickCredentialsLib';

interface YPickLoginQrCodeButtonProps {
  storeId: number;
  fileName: string;
}

/**
 * Button to download QR Code as image to the filesystem
 * @param storeId storeId for which to download the QR Code
 * @param fileName name of the file to save the image as
 */
const YPickLoginQrCodeButton: React.FC<YPickLoginQrCodeButtonProps> = ({ storeId, fileName }) => {
  const [trigger] = useLazyGetYPickLoginQRCodeQuery(); //using this to trigger download only when needed

  const handleDownloadClick = () => {
    trigger(storeId)
      .unwrap()
      .then(qrBlob => {
        if (qrBlob) {
          downloadBlob(qrBlob, fileName);
        }
      });
  };

  return (
    <IconButton
      icon={<MdQrCode size={IconButton_IconSizes.xSmall} />}
      size="xSmall"
      onClick={handleDownloadClick}
    />
  );
};

export default YPickLoginQrCodeButton;
